import Component from "@base/js/component";
import { createFocusTrap } from "focus-trap";

export default class NewsletterPopup extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".newsletter-popup";

  // Defines children that needs to be queried as part of this component
  static children = {
    submit: '.newsletter-form__group [type="submit"]',
    input: ".newsletter-form__input",
    popupClose: ".newsletter-popup__close",
  };

  constructor() {
    super();
    this.trap = createFocusTrap(".newsletter-popup", {
      onActivate: () => {
        document
          .querySelectorAll("body > *:not(.newsletter-popup")
          .forEach((item) => {
            item.setAttribute("aria-hidden", true);
          });
      },
      onDeactivate: () => {
        document
          .querySelectorAll("body > *:not(.newsletter-popup")
          .forEach((item) => {
            item.removeAttribute("aria-hidden", true);
          });
      },
    });
  }

  // Defines event handlers to attach to children
  eventHandlers = {
    input: {
      keyup: this.onKeyUp,
    },

    popupClose: {
      click: this.onPopupClose,
    },
  };

  onPopupClose() {
    this.element.classList.add("hidden");
    this.trap.deactivate();
  }

  onKeyUp() {
    if (this.children.input.value !== "") {
      this.children.submit.removeAttribute("disabled");
    } else {
      this.children.submit.setAttribute("disabled", "");
    }
  }

  afterInit() {
    this.trap.activate();
    this.children.submit.setAttribute("disabled", "");
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
NewsletterPopup.init();
